<p>pub-opening works!</p>
